const checkNAddEmailMapper = (response) => {
    if (response) {
        return {
            message: response.msg,
            status: true,
        };
    }
    return {};
};
export default checkNAddEmailMapper;
